import { AuthStore } from 'auth/storage/auth-storage-manager';
import {
  AuthenticationMethod,
  CreateWebsealAuthMethodProps
} from 'auth/types/authentication-method.type';
import { TokenResponse } from 'auth';
import { getAccess } from 'auth/auth-helpers/get-access';

const logout =
  ({ setSignedInUser, env, navigate }: CreateWebsealAuthMethodProps) =>
  (): Promise<void> => {
    AuthStore.setUserInfo(undefined);
    setSignedInUser(undefined);

    const redirect =
      env.auth.logoutRedirects.find((redirects) => document.referrer.includes(redirects.source)) ??
      env.auth.logoutRedirects.find((redirects) => redirects.default);

    navigate(redirect!.redirectTo);
    return Promise.resolve();
  };

const login = (props: CreateWebsealAuthMethodProps) => async (): Promise<boolean> => {
  const userInfoSuccess = await retrieveUserInfo(props)();
  const getAccessSuccess = await getUserAccess(props)(undefined);
  return userInfoSuccess && getAccessSuccess;
};

const getUserAccess =
  (props: CreateWebsealAuthMethodProps) =>
  async (token: TokenResponse | undefined): Promise<boolean> => {
    const getAccessSuccess = await getAccess({
      getSignedInUser: props.getSignedInUser,
      setSignedInUser: props.setSignedInUser,
      setCurrentAuthenticatedUserWithFeatures: props.setCurrentAuthenticatedUserWithFeatures,
      env: props.env,
      navigate: props.navigate
    })(token);
    if (!getAccessSuccess) {
      const logoutUser = logout(props);
      await logoutUser();
    }
    return getAccessSuccess;
  };

const refreshSession = () => async (): Promise<boolean> => {
  return Promise.resolve(true);
};

const retrieveUserInfo =
  ({ env, setSignedInUser }: CreateWebsealAuthMethodProps) =>
  async (_accessToken?: string): Promise<boolean> => {
    // const config = new Configuration({
    //   basePath: replaceWithDynamicHost(env.apiUrl, env.apiHostMappings)
    // });
    // const securityApi = new SecurityApi(config);
    // const webSealUserInfo = await securityApi.securityGetWebSealUserInfo();
    // if (!webSealUserInfo) return false;
    // const userInfo = mapWebSealUserToUserInfo(webSealUserInfo);
    // AuthStore.setUserInfo(userInfo);
    // setSignedInUser(userInfo);
    return true;
  };

export const createWebsealAuthMethod = (
  props: CreateWebsealAuthMethodProps
): AuthenticationMethod => {
  return {
    logout: logout(props),
    login: login(props),
    retrieveUserInfo: retrieveUserInfo(props),
    getAccess: getUserAccess(props),
    refreshSessionIfExpired: refreshSession(),
    getSignedInUser: props.getSignedInUser,
    identificationState: props.identificationState
  };
};
